
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/RefundPolicy",
      function () {
        return require("private-next-pages/RefundPolicy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/RefundPolicy"])
      });
    }
  